import PropTypes from 'prop-types';
import React from 'react';
import omit from 'lodash.omit';

import StyledCopy from './copy.style';

const Copy = props => {
  const { tag = 'p', children } = props;
  return (
    <StyledCopy {...omit(props, ['children', 'tag'])} as={tag}>
      {children}
    </StyledCopy>
  );
};

Copy.propTypes = {
  children: PropTypes.node,
  tag: PropTypes.oneOf(['span', 'p', 'cite', 'figcaption', 'div', 'li'])
};

export default Copy;
